import React, { useEffect, useState } from "react";
import Axios from "axios";
import { GetCandidateById_Share, GetCourseInfo} from "../apiconstants/constants";
import { useLocation } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import Modal from 'react-bootstrap/Modal';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const HomeViewPartialCandidateDetailsByCandidateGUid = () => {
    let query = useQuery();
    const guid = query.get("guid");
    const detailsType= query.get("detailsType")
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });
    const [qualifications, setQualifications] = useState([]);
    const [jobRoles, setJobRoles] = useState([]);
    let Guid="";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    const GetCandidateDetails = () => {
        setIsLoading(true);
        const GetapiUrl = GetCandidateById_Share.APIURL;
        const params = { guid: guid,type:detailsType };

        Axios.post(GetapiUrl, params)
            .then((result) => {
                setIsLoading(false);
                setCandidateDetails(result.data);
            })
            .catch((error) => {
                console.error("Error fetching candidate details:", error);
            });
    };
    const fetchQualifications = async () => {
        const getApiUrl = GetCourseInfo.APIURL;
        try {
            const response = await Axios.get(getApiUrl);
            setQualifications(response.data);
        } catch (error) {
            console.error("Error fetching qualifications", error);
        }
    };

    const getQualificationName = (id) => {
        const qualification = qualifications.find(q => q.qualificationID == id);
        return qualification ? qualification.courseName : "";
    };

    const handleShowModal = (title, url) => {
        setModalContent({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    const getExperienceText = (experience) => {
        if (!experience) return '';
        return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
      };
    const renderAttachment = (fileUrl) => {
        if (fileUrl) {
            const fileExtension = fileUrl.split('.').pop().toLowerCase();
            if (fileExtension === 'pdf') {
                return (
                    <iframe src={fileUrl} title="Attachment" style={{ width: '100%', height: '500px' }} />
                );
            } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
                return (
                    <img src={fileUrl} alt="Attachment" style={{ width: '100%' }} />
                );
            }else if (fileExtension === 'docx') {
    return (
         <iframe
  src={`https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`}
  width="100%"
  height="600px"
  style={{ border: "none" }}
/>

    );
}
 else {
                return (
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">Download Attachment</a>
                );
            }
        }
        return <p>No attachment available</p>;
    };

    useEffect(() => {
        GetCandidateDetails();
        fetchQualifications();
    }, []);

    return (
        <>
            {candidateDetails ? (
                < div class="container-fluid">
                <h2 className="mb-3 mt-3" style={{ color: "#00a7ac" }}>Candidate Details</h2>
                    <hr />
                    <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                         <div class="row mt-2">
                   
                    
                    <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">

                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Full Name</Tooltip>}>
                        <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.fullName}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                        <p className="text-para"><i className="fa fa-envelope icons"></i> {candidateDetails.email}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Mobile Number</Tooltip>}>
                        <p className="text-para"> <i className="fa fa-phone icons"></i> {candidateDetails.mobileNumber}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-experience">Experience</Tooltip>}>
                        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getExperienceText(candidateDetails.experience)}</p>
                    </OverlayTrigger>
                    {candidateDetails.jobRole!==null && candidateDetails.jobRole!=='null' &&candidateDetails.jobRole!==0 &&   (  
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-currentRole">Job Role</Tooltip>}>
                        <p className="text-para"><i className="fa fa-user-tie icons"></i> {(candidateDetails.jobRoleName)}</p>
                    </OverlayTrigger>)}
                    {candidateDetails.address!==null && candidateDetails.address!=='null' &&   (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-address">Address</Tooltip>}>
                        <p className="text-para"><i className="fa fa-map-marker icons"></i> {candidateDetails.address}</p>
                    </OverlayTrigger>)}
                    {candidateDetails.workMode!==null && candidateDetails.workMode!=='null' &&   ( <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Work Mode</Tooltip>}>
                        <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.workMode}</p>
                    </OverlayTrigger>)}
                  
                                
                                {candidateDetails.resume!==null && candidateDetails.resume!=='null' &&        
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
                                    <p className="text-para">
                                    <a 
            href="#" 
            style={{ fontSize: 18 }} 
            onClick={() => handleShowModal('Resume', candidateDetails.fileUrl)}
          >
            <i className="fa fa-file-alt icons"></i> View Resume
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.fileUrl} 
            style={{ fontSize: 18 }} 
            download
            target="_blank"
          >
            <i className="fa fa-download icons"></i> Download Resume
          </a>                                    </p>
                                </OverlayTrigger> }
                    <Modal show={showModal} onHide={handleCloseModal} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalContent.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {renderAttachment(modalContent.url)}
                                    </Modal.Body>
                                </Modal>
                </div>

                </div>
                </div>
                
            
</div>
            ) : (
                <center><LoadingSpinner /></center>
            )}
        </>
    );
};

export default HomeViewPartialCandidateDetailsByCandidateGUid;
